import SetlistViewContainer from '../../../components/setlistView/SetlistViewContainer';

const SetlistPreview = () => {
  return <SetlistViewContainer isSetlistPreview={true} />;
};

export default SetlistPreview;
